import React from 'react';

const Pool = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M10.3125 6.5625H19.6875"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3125 10.3125H19.6875"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3125 14.0625H19.6875"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3125 3.75V16.5691"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6875 3.75V16.7918"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 19.6875C6.5625 19.6875 6.5625 21.5625 9.375 21.5625C12.1875 21.5625 12.1875 19.6875 15 19.6875C17.8125 19.6875 17.8125 21.5625 20.625 21.5625C23.4375 21.5625 23.4375 19.6875 26.25 19.6875"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 24.375C6.5625 24.375 6.5625 26.25 9.375 26.25C12.1875 26.25 12.1875 24.375 15 24.375C17.8125 24.375 17.8125 26.25 20.625 26.25C23.4375 26.25 23.4375 24.375 26.25 24.375"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Pool;
